import { useEffect, useState } from "react";

import { useTranslation } from "react-i18next";

import useSingleLead from "../../../data/useSingleLead";
import { ILead, QuoteType } from "../../../models/Lead";
import Card from "../../shared/Card/Card";
import LoadingWheel from "../../shared/LoadingWheel";
import { BodyCondition, EngineCondition } from "../../../models/Vehicle";
import { GetQuoteType } from "./QuoteCalculationCard";
import { formatCollectionOption, hasCollectionOption } from "../../../utils/leadPaymentOption";


const SingleDetail = ({ title, value, textColour = "text-gray-900" }: { title: string; value: string | null | undefined; textColour?: string; }) => {
  return (
    <div className="py-2 grid grid-cols-2 gap-4">
      <dt className="text-sm font-medium text-gray-500">{title}</dt>
      <dd className={`${textColour} text-sm`}>{value}</dd>
    </div>
  );
};

export default function WidgetQuoteDetails({ leadId }: { leadId: string }) {
  const { t } = useTranslation("leads");
  const { lead: singleLead } = useSingleLead(leadId, "WidgetQuoteDetails");
  const [lead, setLead] = useState<ILead | undefined>();
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (!singleLead.isLoading && singleLead.data) {
      setLead(singleLead.data.data);
      setIsLoading(false);
    }
  }, [singleLead.isLoading, singleLead.data]);

  if (isLoading || lead == undefined) return <Card bodyClassName="p-4" title={t("Quote Details")}><LoadingWheel /></Card>;

  return (
    <Card bodyClassName="p-4 divide-y divide-gray-200" title={t("Quote Details")} collapsible>
      <SingleDetail title={t("Quote Type")} value={t(GetQuoteType(lead.quoteType!) ?? "")} />
      {hasCollectionOption(lead) ? (
        <SingleDetail title={t("Collection Option")} value={formatCollectionOption(lead)} />
      ) : (
        <>
          <SingleDetail title={t("Road Side Payment")} value={lead.roadSidePayment ? t("Yes") : t("No")} />
          <SingleDetail title={t("Fast Payment")} value={lead.fastPayment ? t("Yes") : t("No")} />
        </>
      )}
      <SingleDetail title={t("Access To Vehicle")} value={lead.accessToVehicle ? t("Yes") : t("No")} />
      <SingleDetail title={t("V5C")} value={lead.v5c ? t("Yes") : t("No")} />
      <SingleDetail title={t("Collection")} value={lead.isCollection ? t("Yes") : t("No")} />
      {lead.preferredCollectionDate && (
        <SingleDetail title={t("Preferred Collection Date")} value={new Date(lead.preferredCollectionDate).toLocaleDateString("en-GB")} />
      )}
      <SingleDetail title={t("Engine Condition")} value={t(EngineCondition[lead?.vehicle?.engineCondition!])} />
      <SingleDetail title={t("Body Condition")} value={t(BodyCondition[lead?.vehicle?.bodyCondition!])} />
      <SingleDetail title={t("Alloy Wheels")} value={lead?.vehicle?.alloyWheels ? t("Yes") : t("No")} />
    </Card>
  );
};